<script setup lang="ts">
import type { CurrentMonthAlternativeProductDayTile } from '../models';

import CalendarTileLayout from './CalendarTileLayout.vue';

interface CurrentMonthAlternativeProductDayTileViewProps {
  calendarTile: CurrentMonthAlternativeProductDayTile;
  showPrices: boolean;
  allowSelection: boolean;
}

const props = defineProps<CurrentMonthAlternativeProductDayTileViewProps>();

interface CurrentMonthAlternativeProductDayTileViewEmits {
  (eventName: 'select-date', date: Date): void;
}

const emit = defineEmits<CurrentMonthAlternativeProductDayTileViewEmits>();
</script>

<template>
  <CalendarTileLayout
    :price-type="props.calendarTile.price.type"
    :selection-type="props.calendarTile.selection"
    :tooltip-text="props.calendarTile.reason"
    :allow-selection="props.allowSelection"
    @click="emit('select-date', props.calendarTile.date)"
  >
    <template #day>
      {{ props.calendarTile.text }}
    </template>
    <template v-if="props.showPrices" #price>
      {{ props.calendarTile.price.value }}
    </template>
  </CalendarTileLayout>
</template>
